import { useState } from 'react';
import { StorageItem } from '../../../services/storageService';
import { TabType } from '../types';

export const useFlashCheckTabs = (files: StorageItem[]) => {
  const [activeTab, setActiveTab] = useState<TabType>('library');

  const getFilteredFiles = (): StorageItem[] => {
    if (activeTab === 'library') {
      return files.filter(file => 
        file.type === 'file' && 
        file.name.toLowerCase().endsWith('.html')
      );
    }
    return files;
  };

  const handleTabChange = (tab: TabType) => {
    setActiveTab(tab);
  };

  return {
    activeTab,
    getFilteredFiles,
    handleTabChange,
    setActiveTab
  };
};
